<template>
  <div>
    <el-dialog
      title="添加优惠券"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose"
    >
      <div class="card">
        <div class="col-lg-12 list-header fix-header clearfix">
          <div class="dsply-fix fix-header-item">
            <b-form-input
              v-model="pageParams.contentKeyword"
              class="w-190 m-r-10"
              size="sm"
              type="text"
              placeholder="搜索优惠券"
            ></b-form-input>
            <b-button
              class="m-r-5"
              size="sm"
              variant="primary"
              @click="getList()"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
        </div>
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px;"></th>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col">名称</th>
                  <th scope="col">类型</th>
                  <th scope="col">总库存</th>
                  <th scope="col">可用库存</th>
                  <th scope="col">发放量</th>
                  <th scope="col">核销量</th>
                  <th scope="col">所属商家</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <!-- <td>
                    <b-form-checkbox
                      v-model="choiceListIds" 
                      :value="item" 
                      checked
                      plain
                      ></b-form-checkbox>
                  </td> -->
                  <td class="media-dialog-radio">
                    <el-radio v-model="choiceListIds" :label="item"></el-radio>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-300px white-inherit">{{ item.title }}</td>
                  <td>
                    <template v-if="item.couponType == 1">代金券</template>
                    <template v-if="item.couponType == 2">折扣券</template>
                    <template v-if="item.couponType == 3">通用券</template>
                  </td>
                  <td>{{ item.countNumber || "--" }}</td>
                  <td>{{ item.quantity || "--" }}</td>
                  <td>{{ item.grantNumber || "0" }}</td>
                  <td>{{ item.verifyNumber || "0" }}</td>
                  <td>{{ item.merchant.name || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <pagination ref="page" @pageCallback="pageCallback"></pagination>
        <app-list-loading ref="loading"></app-list-loading>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue";
import coupon from "../../../server/api/coupons";

export default {
  components: { pagination },

  data() {
    return {
      pageParams: {
        page: 1,
        pageSize: 6,
        "q%5Bmerchant_id%5D": JSON.parse(localStorage.chosedMedia).id,
        contentKeyword: "",
      },
      tagId: "",
      currentTag: "",
      items: [],
      choiceListIds: "", //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      show: false,
    };
  },

  props: {},

  watch: {
    // choiceListIds: function() {
    //   if ( this.choiceListIds.length == this.allListIds.length && this.choiceListIds.length > 0) {
    //     this.indeterminate = true;
    //   } else {
    //     this.indeterminate = false;
    //   }
    // }
  },

  mounted() {},

  methods: {
    showModel() {
      let that = this;
      this.choiceListIds = "";
      this.items = [];
      setTimeout(function(argument) {
        that.resetParams();
      }, 500);
      this.show = true;
    },

    handleClose() {
      this.show = false;
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //获取列表数据
    getList() {
      let params = this.utils.getQuery(this.pageParams);
      this.$refs.loading.show();
      this.items = [];
      coupon.list(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data) {
            this.choiceListIds = "";
            this.items = resp.data.items;
            if (this.$refs.loading) {
              this.$refs.loading.hide(resp.data.items);
            }

            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
              if (this.$refs.page) {
                this.$refs.page.setPages(pages);
              }
            });
          }
        }
      });
    },

    submitCreate() {
      if (this.choiceListIds) {
        if (this.choiceListIds.merchant) {
          if (this.choiceListIds.merchant.name) {
            this.choiceListIds.merchant_name = this.choiceListIds.merchant.name;
          }
        }
      }
      let current = {
        code: "coupon",
        item: this.choiceListIds,
      };
      this.handleClose();
      this.$emit("pageCallback", current);
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.contentKeyword = "";
      this.getList();
    },

    // // 列表全选
    // checkedAll() {
    //   if (this.indeterminate) {
    //     this.choiceListIds = this.allListIds;
    //   } else {
    //     this.choiceListIds = [];
    //   }
    // }
  },
};
</script>
